export class VehicleImportModel {
    counter: number = 0;
    branchCode: number = 0;
    description: string = '';
    typeCode: number = 0;
    plate: string = '';
    capacity: number = 0;
    storeCode: number = 0;
    cityCode: string = "";
    departmentCode: string = "";
    active: boolean = true;
    swExternal: boolean = false;

    constructor(counter: number,
        branchCode: number,
        description: string,
        typeCode: number,
        plate: string,
        capacity: number,
        storeCode: number,
        cityCode: string,
        departmentCode: string,
        active: boolean,
        swExternal: boolean
    ) {
        this.counter = counter;
        this.branchCode = branchCode;
        this.description = description;
        this.typeCode = typeCode;
        this.plate = plate;
        this.capacity = capacity;
        this.storeCode = storeCode;
        this.cityCode = cityCode;
        this.departmentCode = departmentCode;
        this.active = active;
        this.swExternal = swExternal;
    }
}